var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "6187c60dc7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.464844 111.804688 L 195.578125 111.804688 L 195.578125 236.476562 L 112.464844 236.476562 Z M 112.464844 111.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "feaeec8ec5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 154.019531 111.804688 L 112.464844 111.804688 L 154.019531 236.476562 L 195.578125 236.476562 Z M 154.019531 111.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d41afb7ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.464844 0.804688 L 83.578125 0.804688 L 83.578125 125.476562 L 0.464844 125.476562 Z M 0.464844 0.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de26a7e130"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.019531 0.804688 L 0.464844 0.804688 L 42.019531 125.476562 L 83.578125 125.476562 Z M 42.019531 0.804688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d36046db53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 126
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "39cfe41d08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 179.421875 64.121094 L 262.535156 64.121094 L 262.535156 188.792969 L 179.421875 188.792969 Z M 179.421875 64.121094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "23fbf06322"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 220.980469 64.121094 L 262.535156 64.121094 L 220.980469 188.792969 L 179.421875 188.792969 Z M 220.980469 64.121094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1a3983d5d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.421875 0.121094 L 83.535156 0.121094 L 83.535156 124.792969 L 0.421875 124.792969 Z M 0.421875 0.121094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8085238c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.980469 0.121094 L 83.535156 0.121094 L 41.980469 124.792969 L 0.421875 124.792969 Z M 41.980469 0.121094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6d5a675dd3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 125
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6187c60dc7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#feaeec8ec5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 112, 111)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d36046db53)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d41afb7ca)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de26a7e130)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.464844 0.804688 L 83.578125 0.804688 L 83.578125 125.476562 L 0.464844 125.476562 Z M 0.464844 0.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39cfe41d08)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#23fbf06322)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 179, 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6d5a675dd3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1a3983d5d5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8085238c4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.421875 0.121094 L 83.535156 0.121094 L 83.535156 124.792969 L 0.421875 124.792969 Z M 0.421875 0.121094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.489814, 283.540851)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.390625 0 L 0.609375 -24.765625 L 9.109375 -24.765625 L 14.078125 -8.203125 L 14.21875 -8.203125 L 19.21875 -24.765625 L 27.359375 -24.765625 L 18.609375 0 Z M 9.390625 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.497864, 283.540851)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 19.265625 0 L 18.21875 -3.484375 L 9.546875 -3.484375 L 8.5 0 L 0.359375 0 L 9.390625 -24.765625 L 18.640625 -24.765625 L 27.6875 0 Z M 11.203125 -9.03125 L 16.5625 -9.03125 L 13.96875 -17.859375 L 13.828125 -17.859375 Z M 11.203125 -9.03125 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.505915, 283.540851)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 27.328125 -9.96875 C 27.328125 -6.582031 26.257812 -4 24.125 -2.21875 C 21.988281 -0.445312 18.953125 0.4375 15.015625 0.4375 C 11.078125 0.4375 8.03125 -0.445312 5.875 -2.21875 C 3.726562 -4 2.65625 -6.582031 2.65625 -9.96875 L 2.65625 -24.765625 L 10.625 -24.765625 L 10.625 -10.078125 C 10.625 -8.679688 10.992188 -7.570312 11.734375 -6.75 C 12.484375 -5.925781 13.5625 -5.515625 14.96875 -5.515625 C 16.382812 -5.515625 17.472656 -5.929688 18.234375 -6.765625 C 18.992188 -7.609375 19.375 -8.710938 19.375 -10.078125 L 19.375 -24.765625 L 27.328125 -24.765625 Z M 27.328125 -9.96875 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.493977, 283.540851)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.65625 -24.765625 L 10.625 -24.765625 L 10.625 -6.34375 L 23.328125 -6.34375 L 23.328125 0 L 2.65625 0 Z M 2.65625 -24.765625 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.506026, 283.540851)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.921875 -18.4375 L 16.921875 0 L 8.96875 0 L 8.96875 -18.4375 L 0.828125 -18.4375 L 0.828125 -24.765625 L 25.015625 -24.765625 L 25.015625 -18.4375 Z M 16.921875 -18.4375 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.059164, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03125 0 L 1.03125 -9.796875 L 4.484375 -9.796875 C 5.171875 -9.796875 5.738281 -9.6875 6.1875 -9.46875 C 6.644531 -9.25 6.984375 -8.953125 7.203125 -8.578125 C 7.429688 -8.203125 7.546875 -7.78125 7.546875 -7.3125 C 7.546875 -6.675781 7.375 -6.175781 7.03125 -5.8125 C 6.695312 -5.445312 6.289062 -5.191406 5.8125 -5.046875 C 6.175781 -4.984375 6.503906 -4.835938 6.796875 -4.609375 C 7.097656 -4.390625 7.332031 -4.113281 7.5 -3.78125 C 7.675781 -3.445312 7.765625 -3.078125 7.765625 -2.671875 C 7.765625 -2.179688 7.644531 -1.734375 7.40625 -1.328125 C 7.164062 -0.921875 6.804688 -0.597656 6.328125 -0.359375 C 5.847656 -0.117188 5.269531 0 4.59375 0 Z M 2.21875 -5.515625 L 4.390625 -5.515625 C 5.015625 -5.515625 5.492188 -5.660156 5.828125 -5.953125 C 6.171875 -6.242188 6.34375 -6.65625 6.34375 -7.1875 C 6.34375 -7.675781 6.175781 -8.066406 5.84375 -8.359375 C 5.507812 -8.660156 5.015625 -8.8125 4.359375 -8.8125 L 2.21875 -8.8125 Z M 2.21875 -0.984375 L 4.46875 -0.984375 C 5.132812 -0.984375 5.648438 -1.140625 6.015625 -1.453125 C 6.378906 -1.765625 6.5625 -2.203125 6.5625 -2.765625 C 6.5625 -3.304688 6.367188 -3.742188 5.984375 -4.078125 C 5.609375 -4.410156 5.09375 -4.578125 4.4375 -4.578125 L 2.21875 -4.578125 Z M 2.21875 -0.984375 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.316475, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.46875 0 L 3.46875 -3.71875 L 0.28125 -9.796875 L 1.609375 -9.796875 L 4.0625 -4.84375 L 6.515625 -9.796875 L 7.828125 -9.796875 L 4.640625 -3.71875 L 4.640625 0 Z M 3.46875 0 "
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.251967, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.793913, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03125 0 L 1.03125 -9.796875 L 7.09375 -9.796875 L 7.09375 -8.828125 L 2.21875 -8.828125 L 2.21875 -5.421875 L 6.671875 -5.421875 L 6.671875 -4.46875 L 2.21875 -4.46875 L 2.21875 -0.96875 L 7.09375 -0.96875 L 7.09375 0 Z M 1.03125 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.519521, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.375 0.0625 C 1.132812 0.0625 0.9375 -0.0078125 0.78125 -0.15625 C 0.632812 -0.3125 0.5625 -0.503906 0.5625 -0.734375 C 0.5625 -0.953125 0.632812 -1.140625 0.78125 -1.296875 C 0.9375 -1.453125 1.132812 -1.53125 1.375 -1.53125 C 1.59375 -1.53125 1.78125 -1.453125 1.9375 -1.296875 C 2.09375 -1.140625 2.171875 -0.953125 2.171875 -0.734375 C 2.171875 -0.503906 2.09375 -0.3125 1.9375 -0.15625 C 1.78125 -0.0078125 1.59375 0.0625 1.375 0.0625 Z M 1.375 0.0625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.082012, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.15625 0.171875 C 3.4375 0.171875 2.8125 0.0390625 2.28125 -0.21875 C 1.75 -0.476562 1.335938 -0.84375 1.046875 -1.3125 C 0.753906 -1.78125 0.609375 -2.320312 0.609375 -2.9375 L 1.84375 -2.9375 C 1.84375 -2.550781 1.929688 -2.195312 2.109375 -1.875 C 2.285156 -1.5625 2.546875 -1.304688 2.890625 -1.109375 C 3.234375 -0.921875 3.65625 -0.828125 4.15625 -0.828125 C 4.820312 -0.828125 5.335938 -0.984375 5.703125 -1.296875 C 6.066406 -1.617188 6.25 -2.015625 6.25 -2.484375 C 6.25 -2.878906 6.160156 -3.195312 5.984375 -3.4375 C 5.816406 -3.675781 5.59375 -3.867188 5.3125 -4.015625 C 5.03125 -4.160156 4.703125 -4.289062 4.328125 -4.40625 C 3.960938 -4.519531 3.578125 -4.644531 3.171875 -4.78125 C 2.421875 -5.050781 1.863281 -5.378906 1.5 -5.765625 C 1.132812 -6.148438 0.953125 -6.65625 0.953125 -7.28125 C 0.941406 -7.800781 1.0625 -8.265625 1.3125 -8.671875 C 1.5625 -9.078125 1.914062 -9.394531 2.375 -9.625 C 2.84375 -9.851562 3.394531 -9.96875 4.03125 -9.96875 C 4.65625 -9.96875 5.195312 -9.847656 5.65625 -9.609375 C 6.125 -9.378906 6.484375 -9.054688 6.734375 -8.640625 C 6.992188 -8.234375 7.128906 -7.769531 7.140625 -7.25 L 5.90625 -7.25 C 5.90625 -7.519531 5.832031 -7.785156 5.6875 -8.046875 C 5.550781 -8.316406 5.34375 -8.535156 5.0625 -8.703125 C 4.78125 -8.867188 4.421875 -8.953125 3.984375 -8.953125 C 3.453125 -8.960938 3.015625 -8.828125 2.671875 -8.546875 C 2.335938 -8.273438 2.171875 -7.890625 2.171875 -7.390625 C 2.171875 -6.972656 2.289062 -6.648438 2.53125 -6.421875 C 2.769531 -6.203125 3.101562 -6.019531 3.53125 -5.875 C 3.957031 -5.726562 4.453125 -5.5625 5.015625 -5.375 C 5.484375 -5.207031 5.898438 -5.007812 6.265625 -4.78125 C 6.640625 -4.5625 6.929688 -4.273438 7.140625 -3.921875 C 7.359375 -3.566406 7.46875 -3.113281 7.46875 -2.5625 C 7.46875 -2.09375 7.34375 -1.648438 7.09375 -1.234375 C 6.851562 -0.816406 6.488281 -0.476562 6 -0.21875 C 5.507812 0.0390625 4.894531 0.171875 4.15625 0.171875 Z M 4.15625 0.171875 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.003508, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03125 0 L 1.03125 -9.796875 L 2.40625 -9.796875 L 5.9375 -2.96875 L 9.4375 -9.796875 L 10.828125 -9.796875 L 10.828125 0 L 9.640625 0 L 9.640625 -7.703125 L 6.375 -1.40625 L 5.484375 -1.40625 L 2.21875 -7.6875 L 2.21875 0 Z M 1.03125 0 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.688909, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03125 0 L 1.03125 -9.796875 L 2.21875 -9.796875 L 2.21875 0 Z M 1.03125 0 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.769108, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.328125 0 L 3.328125 -8.828125 L 0.40625 -8.828125 L 0.40625 -9.796875 L 7.4375 -9.796875 L 7.4375 -8.828125 L 4.515625 -8.828125 L 4.515625 0 Z M 3.328125 0 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(253.438754, 307.03498)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03125 0 L 1.03125 -9.796875 L 2.21875 -9.796875 L 2.21875 -5.46875 L 7.296875 -5.46875 L 7.296875 -9.796875 L 8.46875 -9.796875 L 8.46875 0 L 7.296875 0 L 7.296875 -4.515625 L 2.21875 -4.515625 L 2.21875 0 Z M 1.03125 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/Vault.2b2b1f744fc1fd213ee9bed5ebb0edb2.svg";
export { ForwardRef as ReactComponent };